import { render, staticRenderFns } from "./addTransfer.vue?vue&type=template&id=2cfbab8c&scoped=true&"
import script from "./addTransfer.vue?vue&type=script&lang=ts&"
export * from "./addTransfer.vue?vue&type=script&lang=ts&"
import style0 from "./addTransfer.vue?vue&type=style&index=0&id=2cfbab8c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cfbab8c",
  null
  
)

export default component.exports